<template>
  <div class="f-ast f-v">
    <div class="t t-xl ta-c m-tx3 m-bx3">
      <template v-if="giftCardLink">
        <div>
          You've redeemed <span v-emoji="`${pointsCost.toLocaleString()} ${pointsName} :${pointsConfig.emoji}:`" class="bold" /> for <span class="bold">{{ listingCopy }}</span>.
        </div>
        <br>
        <div>
          Your gift card will open in a new window, or you can click below to claim it.
        </div>
        <br>
        <a :href="giftCardLink" target="_blank" class="link t-xl">
          Claim your gift card
        </a>
      </template>
      <template v-else>
        Success! You've redeemed <span v-emoji="`${pointsCost.toLocaleString()} ${pointsName} :${pointsConfig.emoji}:`" class="bold" /> for <span class="bold">{{ listingCopy }}</span>.
        <br>
        <span v-if="listing.badge">
          <a class="t t-xl link" :href="`/users/${state.currentUser.id}/profile`">Go to your profile</a> to check out your new badge!
        </span>
        <span v-else-if="showAdminReachOut">
          An admin will reach out to you regarding your redemption.
        </span>
      </template>
    </div>
    <donut-modal-sections-actions
      :button-text="modalButtonText"
      :show-cancel="false"
      :save-mutation="saveMutation"
      :save-args="saveArgs"
    />
  </div>
</template>

<script setup>
  import { computed, onMounted } from 'vue';
  import { useStore } from 'vuex';

  const { state, getters } = useStore();

  const postRedeemFollowUpByMachineName = {
    donut_lore: { subcomponent: 'shoutouts-rewards-modals-donut-lore-lore-unlock', size: 'sm' },
    donut_emoji_kit: { subcomponent: 'shoutouts-rewards-modals-donut-emoji-kit-slack-emoji-zip', size: 'sm' },
  };

  const listing = computed(() => state.modal.data.listing);
  const giftCardLink = computed(() => state.modal.data.gift_card_link);
  const pointsConfig = computed(() => state.modal.data.pointsConfig);
  const pointsName = computed(() => {
    if (listing.value.points_cost === 1) {
      return pointsConfig.value.points_name;
    }
    return pointsConfig.value.points_name_plural;
  });

  const pointsCost = computed(() => {
    if (state.modal.data.gift_card_points_cost) {
      return state.modal.data.gift_card_points_cost;
    }
    return listing.value.points_cost;
  });

  const listingCopy = computed(() => {
    if (state.modal.data.gift_card_points_cost) {
      const dollars = getters['rewardsListings/convertGiftCardPointsToDollars'](
        listing.value,
        state.modal.data.gift_card_points_cost,
      );
      return `a $${dollars} gift card`;
    }
    return listing.value.name;
  });

  const postRedeemFollowUp = computed(() => {
    const key = listing.value?.machine_name;
    if (!key) return null;
    return postRedeemFollowUpByMachineName[key] || null;
  });

  const showAdminReachOut = computed(() => {
    if (!listing.value || listing.value.badge) return false;
    return !postRedeemFollowUp.value;
  });

  const modalButtonText = computed(() => {
    if (postRedeemFollowUp.value) return 'Next';
    return 'Close';
  });

  const saveMutation = computed(() => {
    if (postRedeemFollowUp.value) return 'updateModal';
    return null;
  });

  const saveArgs = computed(() => {
    const followUp = postRedeemFollowUp.value;
    if (!followUp) return null;

    return {
      visible: true,
      ...followUp,
      dismissable: false,
      data: state.modal.data,
    };
  });

  onMounted(() => {
    if (giftCardLink.value) {
      window.open(giftCardLink.value, '_blank');
    }
  });
</script>
